<script setup lang="ts">
import { pythonInteractiveCards } from "~/features/python/data/chapter2-interactive";

withDefaults(defineProps<{
  eyebrow?: string;
  title?: string;
  intro?: string;
  cards?: ReadonlyArray<{
    title: string;
    to: string;
    description: string;
  }>;
}>(), {
  eyebrow: "Python Chapter 2",
  title: "Python Topic Practice",
  intro: "Variables, data types, operators, loops, functions aur programs ko topic-wise practice karein.",
  cards: () => pythonInteractiveCards,
});
</script>

<template>
  <section class="rounded-[28px] border border-slate-200 bg-white p-5 dark:border-slate-800 dark:bg-slate-900 md:p-6">
    <div>
      <p class="text-xs font-semibold uppercase tracking-[0.22em] text-slate-500 dark:text-slate-400">{{ eyebrow }}</p>
      <h2 class="mt-2 text-2xl font-semibold tracking-tight text-slate-950 dark:text-white">{{ title }}</h2>
      <p class="mt-3 text-sm leading-7 text-slate-600 dark:text-slate-300">{{ intro }}</p>
    </div>

    <div class="mt-5 grid gap-3 sm:grid-cols-2 xl:grid-cols-3">
      <NuxtLink
        v-for="item in cards"
        :key="item.to"
        :to="item.to"
        class="rounded-[22px] border border-slate-200 bg-slate-50 p-4 transition hover:border-sky-300 hover:bg-white dark:border-slate-800 dark:bg-slate-950 dark:hover:border-sky-700 dark:hover:bg-slate-900"
      >
        <h3 class="text-base font-semibold text-slate-950 dark:text-white">{{ item.title }}</h3>
        <p class="mt-2 text-sm leading-6 text-slate-600 dark:text-slate-300">{{ item.description }}</p>
        <p class="mt-3 text-sm font-semibold text-sky-700 dark:text-sky-400">Open topic -></p>
      </NuxtLink>
    </div>
  </section>
</template>
